// store/slices/authSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AuthPOSUser {
  name?: string;
  token?: string;
}

export interface AuthState {
  authPOSUser: AuthPOSUser | null;
  isMainStore: boolean;
  isMayaveStore: boolean;
  mayavePurityEdit: boolean;
  roleName: string | null;
  storeId: string | null;
  storedataid: string | null;
  token: string | null;
}

const initialState: AuthState = {
  authPOSUser: null,
  isMainStore: false,
  isMayaveStore: false,
  mayavePurityEdit: false,
  roleName: null,
  storeId: null,
  storedataid: null,
  token: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthData: (state, action: PayloadAction<Partial<AuthState>>) => {
      return { ...state, ...action.payload };
    },
    clearAuthData: () => initialState,
  },
});

export const { setAuthData, clearAuthData } = authSlice.actions;
export default authSlice.reducer;
